var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "q-zoom-in-center" } }, [
    _c(
      "span",
      {
        class: _vm.classes,
        style: "backgroundColor: " + _vm.color,
        on: { click: _vm.handleClick },
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("i", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.closable,
              expression: "closable",
            },
          ],
          staticClass: "q-tag__close q-icon-close",
          style: _vm.isRtl ? "left: -3px;" : "right: -3px;",
          on: { click: _vm.handleClose },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }